/**
 * Configuration for APS/ACC API Client
 * Manages environment variables and API settings
 */

export interface APIConfig {
  clientId: string;
  clientSecret: string;
  authScope: string;
  baseURL: string;
  environment: 'development' | 'staging' | 'production';
  defaultModelUrn: string;
}

class Configuration {
  private config: APIConfig;

  constructor() {
    this.config = {
      clientId: import.meta.env.VITE_APS_CLIENT_ID || '',
      clientSecret: import.meta.env.VITE_APS_CLIENT_SECRET || '',
      authScope: import.meta.env.VITE_APS_AUTH_SCOPE || 'data:read data:write data:create bucket:create bucket:read',
      baseURL: import.meta.env.VITE_API_BASE_URL || 'https://developer.api.autodesk.com',
      environment: (import.meta.env.VITE_ENVIRONMENT as APIConfig['environment']) || 'development',
      defaultModelUrn: import.meta.env.VITE_DEFAULT_MODEL_URN || ''
    };
  }

  get<K extends keyof APIConfig>(key: K): APIConfig[K] {
    return this.config[key];
  }

  getAll(): APIConfig {
    return { ...this.config };
  }

  isValid(): boolean {
    return !!(this.config.clientId && this.config.clientSecret);
  }
}

export const config = new Configuration();

// API Endpoints
export const API_ENDPOINTS = {
  auth: {
    token: '/authentication/v2/token',
    introspect: '/authentication/v2/introspect'
  },
  dataManagement: {
    hubs: '/project/v1/hubs',
    projects: '/project/v1/hubs/:hubId/projects',
    folders: '/data/v1/projects/:projectId/folders',
    contents: '/data/v1/projects/:projectId/folders/:folderId/contents'
  },
  modelDerivative: {
    formats: '/modelderivative/v2/designdata/:urn/manifest',
    metadata: '/modelderivative/v2/designdata/:urn/metadata',
    properties: '/modelderivative/v2/designdata/:urn/metadata/:guid/properties'
  },
  viewer: {
    token: '/authentication/v2/token',
    manifest: '/derivativeservice/v2/manifest/:urn'
  }
};